import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import table_bootstrap from "../components/table_bootstrap.vue"
import accountInformation from '../components/accountInformation.vue'
import options from '../components/options.vue'
import about from '../pages/about.vue'
import support from '../components/support.vue'
import deal from '../pages/deal.vue'
import task from '../pages/task.vue'
import company from '../pages/company.vue'
import contact from '../pages/contact.vue'
import user from '../pages/user.vue'
import planned from '../pages/planned.vue'

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: table_bootstrap
        },
        {
            path: '/accounts',
            component: accountInformation
        },
        {
            path: '/options',
            component: options
        },
        {
            path: '/about',
            component: about
        },
        {
            path: '/support',
            component: support
        },
        {
            path: '/deal',
            component: deal,
            meta: {
                layout: 'compact'
            },
        },
        {
            path: '/task',
            component: task,
            meta: {
                layout: 'compact'
            },
        },
        {
            path: '/company',
            component: company,
            meta: {
                layout: 'compact'
            },
        },
        {
            path: '/user',
            component: user,
            meta: {
                layout: 'compact'
            },
        },
        {
            path: '/contact',
            component: contact,
            meta: {
                layout: 'compact'
            },
        },
        {
            path: '/planned',
            component: planned,
        },

    ]
})